import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { connect } from 'react-redux';
import { gtag4 } from '../../../../utilities/analytics/tracking';
import PersonalInfo from '../Partials/PersonalInfo/PersonalInfo';
import OtpForm from '../Partials/OtpForm/OtpForm';
import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import ElectricityIcon from '../images/electricity.svg';
import { setIsSubmit, setOtpForm, setPersonalInfo, reportDWH} from '../energySaleBlockSlice';
import {createOtp} from '../energySaleBlockAsyncThunk';

const OtpFormPage = (props) => {
  const [isValidPersonalInfo, setIsValidPersonalInfo] = useState(false);
  const [isValidOtpForm, setIsValidOtpForm] = useState(false);

  //page params
  let title = props.isStartWithSelectedPackage ? props.epiText?.titleStartFromPackage : props.epiText?.title;
  let subTitle = props.isStartWithSelectedPackage ? props.epiText?.subTitleStartFromPackage : props.epiText?.subTitle
  let btnText = 'לקבלת קוד אימות';
  let currentPageFunction = handlePageContinue;
  const formid = 'energySaleBlock';
  const isDisplayFooter = true;
  //page params


  useExtendedEffect((runSideEffects) => {
    gtag4({
      event: props.isStartWithSelectedPackage ? 'Energy_Step2_UpdateinfoPage' : 'Energy_Step1_UpdateinfoPage',
      step: props.isStartWithSelectedPackage ? '2' :'1',
      action: 'UpdateinfoPage',
      funnel_name: props.isStartWithSelectedPackage ?  'Marketing_Page' : 'Counter_Check',
    });
    props.reportDWH({ actionType: 'Check Energy Counter', status: 'Ongoing', messageText: props.isStartWithSelectedPackage ? 'Check Energy Counter after Package- Display' : 'Check Energy Counter- Display' })
    if (runSideEffects()) {
    }
  },
  [],);

  useEffect(() => {
    if( isValidPersonalInfo && isValidOtpForm){
      handlePageContinueAfterValid();
    }
  }, [isValidPersonalInfo, isValidOtpForm  ]);

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      { !props.isStartWithSelectedPackage && <Image className='energy-sale-icon' src={ElectricityIcon} />}
      <h1 className='energy-sale-title' dangerouslySetInnerHTML={{__html: title}}></h1>
      <h2 className='energy-sale-sub-title' dangerouslySetInnerHTML={{__html: subTitle}}></h2>
    </div>
  );

  let currentPageView = (<>
        <PersonalInfo
        onSubmit={props.isSubmit}
        onValid={handlePageValidate}
        firstName={props.firstName}
        lastName={props.lastName}
      />
      <OtpForm isSubmit={props.isSubmit} onValid={handlePageValidate} remarkText={props.epiText?.remark}/>
      </>
  );

  return (
    <>
      <div className='energy-sale-content-wrapper'>
        {currentPageHeadline}
        <div className='energy-sale-page-content width-340'>
          <form noValidate id='sale' onSubmit={handleSubmit}>
            {currentPageView}
          </form>
        </div>
      </div>
      <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} formid={formid} />
    </>
  );


  function handlePageValidate(data){
    props.setIsSubmit(false);
    if(data.isValid){
      if(data.personalDetails){
        setIsValidPersonalInfo(true);
        props.setPersonalInfo(data.personalDetails);
      }
      else{
        setIsValidOtpForm(true);
        props.setOtpForm(data.form);
      }
    }
  }

  function handlePageContinueAfterValid() {
    props.createOtp();
    gtag4({
      event: props.isStartWithSelectedPackage ? 'Energy_Step2_UpdateinfoButton' : 'Energy_Step1_UpdateinfoButton',
      step: props.isStartWithSelectedPackage ? '2' :'1',
      button: btnText,
      action: 'UpdateinfoButton',
      funnel_name: props.isStartWithSelectedPackage ?  'Marketing_Page' : 'Counter_Check',
    });
    props.reportDWH({ actionType: 'Check Energy Counter', status: 'Ongoing', messageText: props.isStartWithSelectedPackage ? 'Check Energy Counter after Package- Clicked' : 'Check Energy Counter- Clicked' })
  }


  function handlePageContinue() {
    props.setIsSubmit(true);
  }


  function handleSubmit(event) {
    event.preventDefault();
  }

};

const mapStateToProps = (state) => {
  return {
    isSubmit: state.energySaleBlock.isSubmit,
    isStartWithSelectedPackage: state.energySaleBlock.isStartWithSelectedPackage,
    epiText: state.energySaleBlock.energySaleBlockData.epiText.otpFormPage,
    firstName: state.energySaleBlock.personalInfo.firstName,
    lastName: state.energySaleBlock.personalInfo.lastName,
  };
};

const mapDispatchToProps = {
  setIsSubmit,
  setPersonalInfo,
  setOtpForm,
  reportDWH,
  createOtp
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpFormPage);
